<template>
  <div class="contribute-upload">
    <el-upload
      drag
      class="upload-body"
      action="-"
      ref="upload"
      :show-file-list="false"
      :http-request="httpRequest"
      :accept="accept"
    >
      <div class="upload-content">
        <img class="icon" src="@/assets/icon/yunshangchuan.png" alt="" />
        <div class="info">{{ tipValue }}</div>
        <div class="btn">{{ btnValue }}</div>
      </div>
    </el-upload>
    <div class="mask" v-if="maskShow">
      <el-progress type="circle" :percentage="percentage"></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  name:'ContributeUpload',
  props: {
    // 文件类型过滤
    accept: {
      type: String,
      default: "",
    },
    // 文件上传
    httpRequest: {
      type: Function,
      required: true,
    },
    // 按钮文本
    btnValue: {
      type: String,
      default: "",
    },
    // 提醒文本
    tipValue: {
      type: String,
      default: "",
    },
    // 遮罩状态-
    maskShow: {
      type: Boolean,
      default: false,
    },
    // 上传进度
    percentage: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.contribute-upload {
  width: 100%;
  position: relative;
  user-select: none;
  ::v-deep .el-upload {
    width: 800px;
    height: 430px;
  }
  ::v-deep .el-upload-dragger {
    width: 100%;
    height: calc(100% - 2px);
    border-radius: 20px;
    border: 1px dashed #868686;
    cursor: auto;
  }
  //   ::v-deep .el-upload-dragger:hover {
  //     border: 1px dashed #0054f7;
  //   }

  .upload-body {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 60px 0;
  }
  .upload-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: 160px;
      height: 160px;
    }
    .info {
      font-size: 15px;
      font-weight: 400;
      color: #222222;
      margin: 0px 0 30px;
    }
    .btn {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: #0054f7;
      border-radius: 32px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .mask {
    width: 800px;
    height: 430px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: calc(50% - 400px);
    top: 0;
    z-index: 15;
    background: rgba(0,0,0,.8);
    border-radius: 20px;
    margin-top: 60px;
  }
}
</style>
